module.exports = __webpack_public_path__ + "logos/logo-netlify.c7eb07.svg";